import styled from 'styled-components';

const Wrapper = styled.div`
    width: 80%;
    align-self: center;
    margin: 50px 0px;
    @media screen and (max-width: 576px) {
      width: 100%;
    }
    box-shadow: ${(props) => props.noBox ? 'unset' : '0px 0px 24px rgba(0,0,0,0.36)'};
    // border-radius: 20px;
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./app/containers/Login/components/Wrapper/index.js